import * as types from './TATActionType';

//TAT Data - start
export const fetchTatDataRequest = (data) => ({
    type: types.FETCH_TAT_DATA_REQUEST,
    payload: data
});
export const fetchTatDataSuccess = (data) => ({
    type: types.FETCH_TAT_DATA_SUCCESS,
    payload: data
});
export const fetchTatDataFailure = (error) => ({
    type: types.FETCH_TAT_DATA_FAILURE,
    payload: error
});
//TAT Data - end